document.addEventListener("DOMContentLoaded", function () {
  // API Configuration
  const API_BASE_URL = "https://apibackend.wellbeingnutrition.com";
  const WISHLIST_ENDPOINT = "/api/wishlist";
  const WISHLIST_LIST_ENDPOINT = "/api/wishlist/list";

  // CleverTap tracking function
  function trackEventFromFE(eventName, eventData) {
    if (typeof clevertap !== 'undefined' && clevertap.event && typeof clevertap.event.push === 'function') {
      clevertap.event.push(eventName, eventData);
    }
  }

  // Track CleverTap event for visiting wishlist page
  if(window.location.pathname === "/pages/wishlist") {
    trackEventFromFE('Visit Wishlist Page', {
      source: 'web',
      userId: getCustomerId()
    });
  }

  // Get all wishlist buttons
  const wishlistButtons = document.querySelectorAll(".wishlist-toggle-btn");

  // Load wishlist from API instead of localStorage
  loadUserWishlist();

  // Add navigation event listeners to refresh wishlist when returning from PDP
  window.addEventListener('pageshow', function(event) {
    // Check if page was loaded from cache (back/forward navigation)
    if (event.persisted) {
      loadUserWishlist();
    }
  });

  // Also listen for visibility change (when user switches back to tab)
  document.addEventListener('visibilitychange', function() {
    if (!document.hidden) {
      loadUserWishlist();
    }
  });

  // Update active state for all buttons
  function updateWishlistButtons(wishlistData) {
    wishlistButtons.forEach((btn) => {
      const productId = btn.getAttribute("data-product-id");
      const variantId = btn.getAttribute("data-variant-id");
      const icon = btn.querySelector("svg");

      const isInWishlist = wishlistData.some((item) => {
        const itemProductId = item.product_id || item.productId || item.id;
        const matches = itemProductId == productId;
        return matches;
      });

      if (isInWishlist) {
        icon.classList.add("active");
        icon.setAttribute("fill", "red");
        btn.classList.add("wishlist-active");
      } else {
        icon.classList.remove("active");
        icon.setAttribute("fill", "none");
        btn.classList.remove("wishlist-active");
      }
    });
  }

  async function loadUserWishlist() {
    try {
      const customerId = getCustomerId();
      if (!customerId) {
        setWishlistButtonsInactive();
        return;
      }
      const wishlistData = await fetchUserWishlist(customerId);
      updateWishlistButtons(wishlistData);
    } catch (error) {
      setWishlistButtonsInactive();
    }
  }

  function setWishlistButtonsInactive() {
    wishlistButtons.forEach((btn) => {
      const icon = btn.querySelector("svg");
      icon.classList.remove("active");
      icon.setAttribute("fill", "none");
      btn.classList.remove("wishlist-active");
    });
  }

  function isUserLoggedIn() {
    const customerId = getCustomerId();
    return !!customerId;
  }

  function triggerLoginWrapper() {
    // Redirect to wishlist page instead of login page
    window.location.href = "/pages/wishlist";
  }

  // Add click event listeners to all wishlist buttons (including dynamic)
  function attachWishlistHandler(btn) {
    if (!btn || btn.dataset.wishlistBound === "1") return;
    btn.dataset.wishlistBound = "1";
    btn.addEventListener("click", async function () {
      // Prevent duplicate clicks
      if (btn.disabled) {
        return;
      }

      const productId = btn.getAttribute("data-product-id");
      const variantId = btn.getAttribute("data-variant-id");
      const icon = btn.querySelector("svg");
      
      // Track CleverTap event for heart icon click from PLP/PDP
      const isCurrentlyActive = icon.getAttribute("fill") === "red" || btn.classList.contains("wishlist-active");
      const eventName = isCurrentlyActive ? 'Remove Wishlist' : 'Add Wishlist';
      const customerId = getCustomerId();
      
      trackEventFromFE(eventName, {
        source: 'web',
        product_id: productId,
        variant_id: variantId,
        userId: customerId
      });

      // Use the previously declared isCurrentlyActive variable

      try {
        // Show loading state
        btn.disabled = true;
        icon.style.opacity = "0.5";

        if (!isUserLoggedIn()) {
          triggerLoginWrapper();
          throw new Error(
            "User not logged in. Please log in to manage wishlist."
          );
        }

        if (!isCurrentlyActive) {
          try {
            const result = await addToWishlist(productId, variantId);
            if (result && result.status === "already_exists") {
              icon.classList.add("active");
              icon.setAttribute("fill", "red");
              btn.classList.add("wishlist-active");
            } else {
              icon.classList.add("active");
              icon.setAttribute("fill", "red");
              btn.classList.add("wishlist-active");
            }
          } catch (error) {
            showToast(
              "Failed to add product to wishlist. Please try again.",
              "error"
            );
            throw error;
          }
        } else {
          try {
            await removeFromWishlist(productId, variantId);

            // Update UI to inactive state
            icon.classList.remove("active");
            icon.setAttribute("fill", "none");
            btn.classList.remove("wishlist-active");
          } catch (error) {
            showToast("Failed to remove product from wishlist.");
            throw error; // Re-throw to be caught by outer catch block
          }
        }
      } catch (error) {
        // Special handling for not-logged-in case
        try {
          if (
            error &&
            typeof error.message === "string" &&
            error.message.toLowerCase().includes("not logged in")
          ) {
            showToast("Please log in first to add in Wishlist", "error");
          }
        } catch (_) {}

        // Revert visual state on error to maintain consistency
        if (isCurrentlyActive) {
          // Was active, keep it active on error
          icon.classList.add("active");
          icon.setAttribute("fill", "red");
          btn.classList.add("wishlist-active");
        } else {
          // Was inactive, keep it inactive on error
          icon.classList.remove("active");
          icon.setAttribute("fill", "none");
          btn.classList.remove("wishlist-active");
        }

        // Show user-friendly error message
        // const operation = isCurrentlyActive
        //   ? "remove from wishlist"
        //   : "add to wishlist";
        // showWishlistError(`Failed to ${operation}. Please try again.`);
      } finally {
        // Reset loading state
        btn.disabled = false;
        icon.style.opacity = "1";
      }
    });
  }
  wishlistButtons.forEach(attachWishlistHandler);

  // API Functions
  async function fetchUserWishlist(customerId) {
    const response = await fetch(
      `${API_BASE_URL}${WISHLIST_LIST_ENDPOINT}/${customerId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "Cache-Control": "no-cache, no-store, must-revalidate",
          "Pragma": "no-cache",
          "Expires": "0",
        },
      }
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const result = await response.json();

    // Handle the API response format - customerProductIds array
    if (result.customerProductIds && Array.isArray(result.customerProductIds)) {
      // Convert the array of product IDs to the format expected by updateWishlistButtons
      const wishlistItems = result.customerProductIds.map((productId) => ({
        product_id: productId,
        id: productId,
      }));

      return wishlistItems;
    } else {
      return [];
    }
  }

  async function addToWishlist(productId, variantId) {
    // Get required values
    const customerId = getCustomerId();

    // Validate required fields
    if (!customerId) {
      throw new Error("Customer ID is required but not found");
    }

    if (!variantId) {
      throw new Error("Variant ID is required but not found");
    }

    if (!productId) {
      throw new Error("Product ID is required but not found");
    }

    const requestBody = {
      customerId: customerId,
      productId: productId,
      variantId: variantId,
      sourcePlatform: "web",
      sourceAction: "direct",
    };

    const response = await fetch(`${API_BASE_URL}${WISHLIST_ENDPOINT}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(requestBody),
    });

    if (!response.ok) {
      const errorText = await response.text();

      // Handle specific error codes
      if (response.status === 409) {
        showToast("Product is already in your wishlist!", "info");
        // Don't throw error for 409, just return success
        return {
          status: "already_exists",
          message: "Product already in wishlist",
        };
      }

      throw new Error(`HTTP error! status: ${response.status} - ${errorText}`);
    }

    const result = await response.json();
    
    showToast("Product added to Wishlist", "success");
    return result;
  }

  async function removeFromWishlist(productId, variantId) {
    const customerId = getCustomerId();
    if (!customerId) {
      throw new Error("Customer ID not found");
    }

    // Check if user is logged in
    if (!isUserLoggedIn()) {
      triggerLoginWrapper();
      throw new Error(
        "User not logged in. Please log in to remove from wishlist."
      );
    }

    // Build query parameters
    const queryParams = new URLSearchParams({
      variantId: variantId,
      productId: productId,
      sourcePlatform: "web",
    });

    const response = await fetch(
      `${API_BASE_URL}${WISHLIST_ENDPOINT}/${customerId}/?${queryParams}`,
      {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      }
    );

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`HTTP error! status: ${response.status} - ${errorText}`);
    }

    const result = await response.json();
    
    showToast("Product Removed From Wishlist", "success");
    return result;
  }

    function getCustomerId() {
      try {
        // Directly get customer ID from localStorage
        const gokwikUserId = localStorage.getItem("kp_customer_id");
        return gokwikUserId || null;
      } catch (_) {
        return null;
      }
    }
  // --- MERGED CUSTOMER ID HANDLER + GETTER ---



  function getVariantId() {
    const variantOptions = document.querySelectorAll("[data-variant-id]");
    if (variantOptions.length > 0) {
      const firstVariantId = variantOptions[0].getAttribute("data-variant-id");

      if (firstVariantId) {
        return firstVariantId;
      }
    }
    return null;
  }

  // Utility function to show error messages
  function showWishlistError(message) {
    // Use our toast notification system for errors
    showToast(message, "error");
  }

  // Toast notification functions
  function showToast(message, type = "success") {
    // Remove existing toast if present
    const existingToast = document.querySelector(".wishlist-toast");
    if (existingToast) {
      existingToast.remove();
    }

    // Create toast element
    const toast = document.createElement("div");
    toast.className = `wishlist-toast wishlist-toast-${type}`;
    toast.innerHTML = `
      <div class="toast-content">
        <span class="toast-message">${message}</span>
      </div>
    `;

    // Add styles
    toast.style.cssText = `
      position: fixed;
      top: 20px;
      left: 50%;
      transform: translateX(-50%) translateY(-100%);
      background: #000;
      color: #fff;
      padding: 12px 16px;
      border-radius: 6px;
      box-shadow: 0 4px 12px rgba(0,0,0,0.3);
      z-index: 10000;
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
      font-size: 13px;
      max-width: 280px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      transition: transform 0.3s ease;
    `;

    // Add content styles
    const content = toast.querySelector(".toast-content");
    content.style.cssText = `
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
    `;

    // Add mobile-specific responsive styles
    const mediaQuery = window.matchMedia('(max-width: 480px)');
    if (mediaQuery.matches) {
      toast.style.cssText += `
        padding: 8px 12px;
        font-size: 12px;
        max-width: 240px;
        top: 16px;
      `;
    }

    // Add to page
    document.body.appendChild(toast);

    // Animate in
    setTimeout(() => {
      toast.style.transform = "translateX(-50%) translateY(0)";
    }, 100);

    // Auto remove after 4 seconds
    setTimeout(() => {
      if (toast.parentElement) {
        toast.style.transform = "translateX(-50%) translateY(-100%)";
        setTimeout(() => {
          if (toast.parentElement) {
            toast.remove();
          }
        }, 300);
      }
    }, 4000);
  }

  // init PLP tags for dynamically injected cards
  function tryInitializePlpTags() {
    try {
      if (typeof initializeTagDisplay === "function") {
        initializeTagDisplay();
        return;
      }
    } catch (_) {}

    // render tags directly and apply visibility logic
    try {
      const containers = document.querySelectorAll(".plp_tags_container");

      containers.forEach((container) => {
        if (container.classList.contains("empty-tags-container")) return;
        if (container.children && container.children.length > 0) return;

        const tagsData = container.getAttribute("data-tags");
        if (!tagsData) return;

        const fragment = document.createDocumentFragment();
        tagsData.split(",").forEach((tagText) => {
          const span = document.createElement("span");
          span.className = "plp_product_tags";
          span.textContent = tagText;
          fragment.appendChild(span);
        });
        container.appendChild(fragment);
      });

      // Apply tag visibility logic (similar to theme's updateTagsVisibility)
      requestAnimationFrame(() => {
        containers.forEach((container) => {
          if (container.classList.contains("empty-tags-container")) return;

          const containerRect = container.getBoundingClientRect();
          const tags = container.querySelectorAll(".plp_product_tags");

          tags.forEach((tag) => {
            const rect = tag.getBoundingClientRect();
            if (
              rect.left >= containerRect.left &&
              rect.right <= containerRect.right
            ) {
              tag.style.display = "inline-block";
            } else {
              tag.style.display = "none";
            }
          });
        });
      });
    } catch (_) {}
  }

  function computeGridClass(perRow) {
    switch (perRow) {
      case 2:
        return "medium-up--one-half";
      case 3:
        return "small--one-half medium-up--one-third";
      case 4:
        return "small--one-half medium-up--one-quarter";
      case 5:
        return "small--one-half medium-up--one-fifth";
      default:
        return "small--one-third medium-up--one-sixth";
    }
  }

  // Inject Judge.me rating text on wishlist page under each preview badge
  function injectJudgeMeReviewText(rootEl) {
    try {
      const onWishlistPage =
        typeof window !== "undefined" &&
        window.location &&
        window.location.pathname.indexOf("/pages/wishlist") === 0;
      if (!onWishlistPage) return;

      const scope = rootEl || document;
      const badges = scope.querySelectorAll(".jdgm-prev-badge");
      if (!badges || !badges.length) return;

      badges.forEach((badge) => {
        try {
          if (badge.querySelector(".jdgm-wishlist-rating")) return; // prevent duplicates

          const numReviews = badge.getAttribute("data-number-of-reviews");
          const avgRatingRaw = badge.getAttribute("data-average-rating");

          if (!numReviews && !avgRatingRaw) return;

          const average = parseFloat(avgRatingRaw);
          if (!isFinite(average)) return;

          const averageFormatted = average.toFixed(2);
          const span = document.createElement("span");
          span.className = "jdgm-wishlist-rating";
          span.textContent = `${averageFormatted}/5 (${numReviews || 0})`;
          badge.appendChild(span);
        } catch (_) {}
      });
    } catch (_) {}
  }

  // Pagination state
  let currentPage = 1;
  // Function to get items per page based on device type
  function getItemsPerPage() {
    // Mobile web (screen width <= 768px): 10 items per page
    // Desktop web (screen width > 768px): 9 items per page
    return window.innerWidth <= 768 ? 10 : 9;
  }
  let totalProducts = [];
  let totalPages = 1;

  // Loading state helpers for wishlist page
  function showWishlistLoading() {
    const grid = document.getElementById("wishlist-grid");
    const loader = document.getElementById("wishlist-loading");
    const pagination = document.getElementById("wishlist-pagination");
    const empty = document.getElementById("wishlist-empty-state");

    if (grid) grid.style.display = "none";
    if (pagination) pagination.style.display = "none";
    if (empty) empty.style.display = "none";
    if (loader) {
      loader.style.display = "flex";
      loader.setAttribute("aria-hidden", "false");
    }
  }

  function hideWishlistLoading() {
    const grid = document.getElementById("wishlist-grid");
    const loader = document.getElementById("wishlist-loading");
    if (loader) {
      loader.style.display = "none";
      loader.setAttribute("aria-hidden", "true");
    }
    if (grid) grid.style.display = "";
  }

  // Wishlist Page Client Rendering (Hybrid: Liquid + JS)
  (async function renderWishlistPageIfNeeded() {
    const wishlistGrid = document.getElementById("wishlist-grid");
    if (!wishlistGrid) return;

    try {
      showWishlistLoading();
      const customerId = getCustomerId();
      if (!customerId) {
        hideWishlistLoading();
        return;
      }
      // Get product IDs via backend API
      const idsResponse = await fetch(
        `${API_BASE_URL}${WISHLIST_LIST_ENDPOINT}/${customerId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            "ngrok-skip-browser-warning": "any",
            "Cache-Control": "no-cache, no-store, must-revalidate",
            "Pragma": "no-cache",
            "Expires": "0",
          },
        }
      );
      if (!idsResponse.ok)
        throw new Error(`Wishlist ids fetch failed ${idsResponse.status}`);
      const idsPayload = await idsResponse.json();
      const productIds = Array.isArray(idsPayload.customerProductIds)
        ? idsPayload.customerProductIds
        : [];
      if (!productIds.length) {
        const emptyEl = document.getElementById("wishlist-empty-state");
        hideWishlistLoading();
        if (emptyEl) emptyEl.style.display = "";
        return;
      }

      // Store total products for pagination
      totalProducts = productIds;
      totalPages = Math.ceil(totalProducts.length / getItemsPerPage());

      // Initialize pagination
      await renderWishlistPage(currentPage);
    } catch (err) {
      hideWishlistLoading();
      const emptyEl = document.getElementById("wishlist-empty-state");
      if (emptyEl) emptyEl.style.display = "";
    }
  })();

  // Function to render a specific page of wishlist items
  async function renderWishlistPage(page) {
    const wishlistGrid = document.getElementById("wishlist-grid");
    if (!wishlistGrid) return;

    try {
      showWishlistLoading();
      // Calculate pagination
      const itemsPerPage = getItemsPerPage();
      const startIndex = (page - 1) * itemsPerPage;
      const endIndex = startIndex + itemsPerPage;
      const pageProducts = totalProducts.slice(startIndex, endIndex);

      // Get configuration from grid element
      const sfToken = wishlistGrid.getAttribute("data-sf-token");
      const sfVersion =
        wishlistGrid.getAttribute("data-sf-version") || "2024-07";
      const shopDomain = wishlistGrid.getAttribute("data-shop-domain");
      const shopCurrency =
        wishlistGrid.getAttribute("data-shop-currency") || "INR";
      const perRow = parseInt(
        wishlistGrid.getAttribute("data-per-row") || "3",
        10
      );

      if (!sfToken || !shopDomain) {
        return;
      }

      // Use only the products for current page
      const gidIds = pageProducts.map(
        (id) => `gid://shopify/Product/${id}`
      );

      const query = `
        query WishlistProducts($ids: [ID!]!) {
          nodes(ids: $ids) {
            ... on Product {
              id
              handle
              title
              vendor
              availableForSale
              featuredImage { url altText }
              variants(first: 10) {
                edges {
                  node {
                    id
                    title
                    availableForSale
                    price { amount currencyCode }
                    compareAtPrice { amount currencyCode }
                    image { url altText }
                  }
                }
              }
            }
          }
        }
      `;

      const sfResp = await fetch(
        `https://${shopDomain}/api/${sfVersion}/graphql.json`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Shopify-Storefront-Access-Token": sfToken,
            Accept: "application/json",
          },
          body: JSON.stringify({ query, variables: { ids: gidIds } }),
        }
      );

      if (!sfResp.ok) throw new Error(`Storefront API error ${sfResp.status}`);
      const sfJson = await sfResp.json();
      if (sfJson.errors) {
        throw new Error("Storefront API GraphQL errors");
      }

      const productsFromAPI =
        sfJson.data && Array.isArray(sfJson.data.nodes)
          ? sfJson.data.nodes.filter(Boolean)
          : [];

      if (!productsFromAPI.length) {
        const emptyEl = document.getElementById("wishlist-empty-state");
        if (emptyEl) emptyEl.style.display = "";
        hideWishlistLoading();
        return;
      }

      // Sort products to match the original order from pageProducts
      const products = [];
      pageProducts.forEach(productId => {
        const product = productsFromAPI.find(p => p.id.split("/").pop() === productId);
        if (product) {
          products.push(product);
        }
      });

      // Clear grid and render current page products
      wishlistGrid.innerHTML = "";

      const cardPromises = products.map(async (product, index) => {
        try {
          const numericProductId = product.id.split("/").pop();
          const firstVariant = product.variants.edges[0]?.node;
          const numericVariantId = firstVariant ? firstVariant.id.split("/").pop() : "";

          // Fetch server-rendered card HTML from the wishlist-card view
          const cardUrl = `/products/${product.handle}?view=wishlist-card${numericVariantId ? `&variant=${numericVariantId}` : ''}`;
          const cardResp = await fetch(cardUrl, {
            method: "GET",
            headers: { Accept: "text/html" },
          });
          if (!cardResp.ok) return { index, cardEl: null };
          const cardHtml = (await cardResp.text()).trim();
          if (!cardHtml) return { index, cardEl: null };

          const temp = document.createElement("div");
          temp.innerHTML = cardHtml;
          const cardEl =
            temp.querySelector(".grid__item.grid-product") ||
            temp.firstElementChild;
          if (!cardEl) return { index, cardEl: null };

          // Ensure helpful attributes are present
          if (!cardEl.getAttribute("data-product-handle")) {
            cardEl.setAttribute("data-product-handle", product.handle);
          }
          if (!cardEl.getAttribute("data-product-id") && numericProductId) {
            cardEl.setAttribute("data-product-id", numericProductId);
          }

          // Force-load images if they were set to lazy and didn't start loading
          cardEl.querySelectorAll("img").forEach((img) => {
            try {
              if (img.getAttribute("loading") === "lazy") {
                img.setAttribute("loading", "eager");
              }

              const src = img.getAttribute("src");
              if (src) img.setAttribute("src", src);
            } catch (_) {}
          });

          // Ensure wishlist heart reflects active state for wishlist items
          const heartBtn = cardEl.querySelector(".wishlist-toggle-btn");
          if (heartBtn && pageProducts.includes(numericProductId)) {
            heartBtn.classList.add("wishlist-active");
            const heartSvg = heartBtn.querySelector("svg");
            if (heartSvg) {
              heartSvg.classList.add("active");
              heartSvg.setAttribute("fill", "red");
            }
          }

          return { index, cardEl };
        } catch (_) {
          return { index, cardEl: null };
        }
      });

      // Wait for all cards to be processed in parallel
      const cardResults = await Promise.all(cardPromises);

      // Get the correct grid classes for the current products_per_row setting
      const gridClass = computeGridClass(perRow);
      
      // Sort results by original index and append to grid in correct order
      cardResults
        .sort((a, b) => a.index - b.index)
        .forEach(({ cardEl }) => {
          if (cardEl) {
            // Ensure the card has the proper grid classes for responsive layout
            if (gridClass) {
              // Remove any existing grid classes first
              cardEl.classList.remove(
                'small--one-half', 'small--one-third', 'small--one-quarter', 'small--one-fifth', 'small--one-sixth',
                'medium-up--one-half', 'medium-up--one-third', 'medium-up--one-quarter', 'medium-up--one-fifth', 'medium-up--one-sixth'
              );
              // Add the correct grid classes
              gridClass.split(' ').forEach(cls => {
                if (cls.trim()) {
                  cardEl.classList.add(cls.trim());
                }
              });
            }
            
            // Ensure the card has the base grid__item class
            if (!cardEl.classList.contains('grid__item')) {
              cardEl.classList.add('grid__item');
            }
            
            wishlistGrid.appendChild(cardEl);
          }
        });

      // Ensure PLP tags are initialized for the newly injected cards
      tryInitializePlpTags();

      // Bind dynamic wishlist buttons and add-to-cart buttons
      wishlistGrid
        .querySelectorAll(".wishlist-toggle-btn")
        .forEach(attachWishlistHandler);

      // Bind add-to-cart buttons (if present in rendered card)
      wishlistGrid.querySelectorAll(".add-to-cart.cartAdd_btn").forEach(attachAddToCartHandler);

      // Attach variant selection handlers for image/price updates
      attachVariantHandlers(wishlistGrid);

      // Try to reinitialize theme variant functions if available
      try {
        if (typeof initializeVariantSelection === "function") {
          initializeVariantSelection();
        }
        if (typeof updatePriceVisibility === "function") {
          updatePriceVisibility();
        }
      } catch (_) {}

      // Re-initialize Judge.me badges if their script is present
      try {
        if (window.jdgm) {
          if (typeof window.jdgm.renderBadges === "function") {
            window.jdgm.renderBadges();
          }
          if (typeof window.jdgm.initializeBadges === "function") {
            window.jdgm.initializeBadges();
          }
          if (typeof window.jdgm.initializeWidgets === "function") {
            window.jdgm.initializeWidgets();
          }
        }
      } catch (e) {
        return;
      }

      // Inject readable rating text under Judge.me badge on wishlist page
      injectJudgeMeReviewText(wishlistGrid);
      // In case Judge.me re-renders asynchronously, try once more shortly after
      setTimeout(() => injectJudgeMeReviewText(wishlistGrid), 300);

      // Start observing wishlist changes
      startWishlistObserver(wishlistGrid, pageProducts);

      // Update pagination controls
      updatePaginationControls();
      hideWishlistLoading();
    } catch (err) {
      hideWishlistLoading();
      const emptyEl = document.getElementById("wishlist-empty-state");
      if (emptyEl) emptyEl.style.display = "";
    }
  }

  // Function to update pagination controls using existing pagination pattern
  function updatePaginationControls() {
    const paginationContainer = document.getElementById("wishlist-pagination");
    if (!paginationContainer) return;

    // Show/hide pagination based on total pages
    if (totalPages <= 1) {
      paginationContainer.style.display = "none";
      return;
    } else {
      paginationContainer.style.display = "block";
    }

    // Create pagination HTML following the existing pagination.liquid pattern
    let paginationHTML = `<div class="pagination">`;

    // Previous button
    if (currentPage > 1) {
      paginationHTML += `
        <span class="prev">
          <a href="#" data-page="${currentPage - 1}" title="Previous">
            <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-left" viewBox="0 0 284.49 498.98">
              <path d="M249.49 0a35 35 0 0 1 24.75 59.75L84.49 249.49l189.75 189.74a35.002 35.002 0 1 1-49.5 49.5L10.25 274.24a35 35 0 0 1 0-49.5L224.74 10.25A34.89 34.89 0 0 1 249.49 0Z"/>
            </svg>
            <span class="icon__fallback-text">Previous</span>
          </a>
        </span>
      `;
    }

    // Generate page parts similar to Shopify's paginate.parts
    const maxVisiblePages = 7; // Similar to Shopify's default
    let startPage = 1;
    let endPage = totalPages;

    // If we have too many pages, limit the visible range
    if (totalPages > maxVisiblePages) {
      const halfVisible = Math.floor(maxVisiblePages / 2);
      startPage = Math.max(1, currentPage - halfVisible);
      endPage = Math.min(totalPages, currentPage + halfVisible);

      // Adjust if we're near the beginning or end
      if (endPage - startPage < maxVisiblePages - 1) {
        if (startPage === 1) {
          endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);
        } else {
          startPage = Math.max(1, endPage - maxVisiblePages + 1);
        }
      }
    }

    // Add ellipsis and first page if needed
    if (startPage > 1) {
      paginationHTML += `
        <span class="page">
          <a href="#" data-page="1">1</a>
        </span>
      `;
      if (startPage > 2) {
        paginationHTML += `<span class="page">…</span>`;
      }
    }

    // Page numbers
    for (let i = startPage; i <= endPage; i++) {
      if (i === currentPage) {
        paginationHTML += `<span class="page current">${i}</span>`;
      } else {
        paginationHTML += `
          <span class="page">
            <a href="#" data-page="${i}">${i}</a>
          </span>
        `;
      }
    }

    // Add ellipsis and last page if needed
    if (endPage < totalPages) {
      if (endPage < totalPages - 1) {
        paginationHTML += `<span class="page">…</span>`;
      }
      paginationHTML += `
        <span class="page">
          <a href="#" data-page="${totalPages}">${totalPages}</a>
        </span>
      `;
    }

    // Next button
    if (currentPage < totalPages) {
      paginationHTML += `
        <span class="next">
          <a href="#" data-page="${currentPage + 1}" title="Next">
            <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-right" viewBox="0 0 284.49 498.98">
              <title>icon-chevron</title>
              <path d="M35 498.98a35 35 0 0 1-24.75-59.75l189.74-189.74L10.25 59.75a35.002 35.002 0 0 1 49.5-49.5l214.49 214.49a35 35 0 0 1 0 49.5L59.75 488.73A34.89 34.89 0 0 1 35 498.98Z"/>
            </svg>
            <span class="icon__fallback-text">Next</span>
          </a>
        </span>
      `;
    }

    paginationHTML += `</div>`;

    paginationContainer.innerHTML = paginationHTML;

    // Add click handlers for pagination links
    paginationContainer.querySelectorAll("a[data-page]").forEach((link) => {
      link.addEventListener("click", async (e) => {
        e.preventDefault();
        const targetPage = parseInt(
          e.target.closest("a").getAttribute("data-page")
        );
        if (targetPage && targetPage !== currentPage) {
          currentPage = targetPage;
          await renderWishlistPage(currentPage);

          // Scroll to top of wishlist
          const wishlistGrid = document.getElementById("wishlist-grid");
          if (wishlistGrid) {
            wishlistGrid.scrollIntoView({ behavior: "smooth", block: "start" });
          }
        }
      });
    });
  }

  function attachAddToCartHandler(btn) {
    if (!btn || btn.dataset.addToCartBound === "1") return;
    btn.dataset.addToCartBound = "1";
    btn.addEventListener("click", async function (e) {
      e.preventDefault();
      const variantId = btn.getAttribute("data-variant-id");
      if (!variantId) return;
  
      btn.disabled = true;
      btn.innerHTML = "<span>Adding...</span>";
  
      try {
        const formData = new FormData();
        formData.append("id", variantId);
        formData.append("quantity", "1");
  
        const response = await fetch("/cart/add.js", {
          method: "POST",
          body: formData,
        });
  
        if (response.ok) {
          const addedItem = await response.json();
          
          btn.innerHTML = "<span>Added!</span>";
          setTimeout(() => {
            btn.innerHTML = "<span>Add to cart</span>";
            btn.disabled = false;
          }, 2000);

          // Use theme's cart system for proper UI updates and CDP tracking
          if (typeof theme !== 'undefined' && theme.CartDrawer) {
            const cart = new theme.CartDrawer();
            cart.init();
            
            // Open cart drawer after a short delay
            setTimeout(function() {
              cart.open();
            }, 100);
          }
          
          // Dispatch cart:updated event with proper structure for CDP tracking
          document.dispatchEvent(new CustomEvent("cart:updated", {
            detail: {
              cart: {
                ...addedItem,
                items_added: [addedItem],
                items_removed: []
              }
            }
          }));

          // Update cart count using theme's method
          function updateCartCount() {
            if (typeof $ !== 'undefined') {
              $.getJSON("/cart.js", function (cart) {
                $(".cart-link__bubble").text(cart.item_count);
                $(".your-cart-count").text(cart.item_count);
              });
            } else {
              // Fallback using fetch if jQuery is not available
              fetch("/cart.js")
                .then(response => response.json())
                .then(cart => {
                  const cartBubble = document.querySelector(".cart-link__bubble");
                  const cartCount = document.querySelector(".your-cart-count");
                  if (cartBubble) cartBubble.textContent = cart.item_count;
                  if (cartCount) cartCount.textContent = cart.item_count;
                });
            }
          }
          updateCartCount();
        }
      } catch (error) {
        console.error('Add to cart error:', error);
        btn.innerHTML = "<span>Add to cart</span>";
        btn.disabled = false;
      }
    });
  }

  // Attach variant selection handlers to dynamically loaded cards
  function attachVariantHandlers(container) {
    if (!container) return;

    const variantButtons = container.querySelectorAll(".bze-option");
    variantButtons.forEach((btn) => {
      if (btn.dataset.variantBound === "1") return;
      btn.dataset.variantBound = "1";

      btn.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();

        const dataPrice = btn.dataset.var_price;
        const dataCompare = btn.dataset.var_sale_price;
        const dataDiscount = btn.dataset.discount;
        const dataImg = btn.dataset.master;
        const variantId = btn.dataset.variantid;

        // Get the product container
        let productContainer = btn.closest(".grid-product__content");
        if (!productContainer) {
          productContainer = btn.closest(".grid__item");
        }
        if (!productContainer) return;

        // Update active state
        const siblings = btn.parentElement.querySelectorAll(".bze-option");
        siblings.forEach((sibling) => sibling.classList.remove("active"));
        btn.classList.add("active");

        // Update prices
        const mainPrice = productContainer.querySelector(".main-price");
        const originalPrice = productContainer.querySelector(
          ".grid-product__price--original"
        );
        const savingsPrice = productContainer.querySelector(
          ".grid-product__price--savings"
        );

        if (mainPrice && dataPrice) mainPrice.textContent = dataPrice;
        if (originalPrice && dataCompare)
          originalPrice.textContent = dataCompare;
        if (savingsPrice && dataDiscount)
          savingsPrice.textContent = dataDiscount;

        // Update product image with smooth transition
        if (dataImg) {
          const productImages = [
            ...productContainer.querySelectorAll(".grid-product__image"),
            ...productContainer.querySelectorAll(".image-element img"),
          ];

          productImages.forEach((img) => {
            if (img && img.src !== dataImg) {
              // Add transition effect
              img.style.transition = "opacity 0.3s ease-in-out";
              img.style.opacity = "0.5";

              setTimeout(() => {
                img.setAttribute("srcset", dataImg);
                img.setAttribute("src", dataImg);
                img.style.opacity = "1";
              }, 150);
            }
          });
        }

        // Update add to cart button variant ID
        const addToCartBtns = productContainer.querySelectorAll(
          ".add-to-cart, .cartAdd_btn"
        );
        addToCartBtns.forEach((cartBtn) => {
          if (variantId) {
            cartBtn.setAttribute("data-variant-id", variantId);
          }
        });

        // Update wishlist button variant ID if present
        const wishlistBtn = productContainer.querySelector(
          ".wishlist-toggle-btn"
        );
        if (wishlistBtn && variantId) {
          wishlistBtn.setAttribute("data-variant-id", variantId);
        }
      });
    });
  }

  // MutationObserver to watch for wishlist changes and remove products
  function startWishlistObserver(wishlistGrid, currentProductIds) {
    if (!wishlistGrid) return;

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (
          mutation.type === "attributes" &&
          mutation.attributeName === "class"
        ) {
          const target = mutation.target;

          // Check if this is a wishlist button that changed state
          if (target.classList.contains("wishlist-toggle-btn")) {
            const productId = target.getAttribute("data-product-id");
            const isActive =
              target.classList.contains("wishlist-active") ||
              target.querySelector("svg")?.getAttribute("fill") === "red";

            // If button became inactive (removed from wishlist)
            if (
              !isActive &&
              productId &&
              currentProductIds.includes(productId)
            ) {
              // Find and remove the product from the grid
              const productCard = target.closest(".grid__item.grid-product");
              if (productCard) {
                // Animate removal
                productCard.style.transition =
                  "opacity 0.3s ease, transform 0.3s ease";
                productCard.style.opacity = "0";
                productCard.style.transform = "scale(0.8)";

                setTimeout(async () => {
                  productCard.remove();

                  // Update the global product IDs array
                  const globalIndex = totalProducts.indexOf(productId);
                  if (globalIndex > -1) {
                    totalProducts.splice(globalIndex, 1);
                  }

                  // Update the current page product IDs array
                  const pageIndex = currentProductIds.indexOf(productId);
                  if (pageIndex > -1) {
                    currentProductIds.splice(pageIndex, 1);
                  }

                  // Recalculate pagination
                  totalPages = Math.ceil(totalProducts.length / getItemsPerPage());

                  // Check if current page is now empty or beyond available pages
                  if (
                    wishlistGrid.children.length === 0 ||
                    currentPage > totalPages
                  ) {
                    if (totalProducts.length === 0) {
                      // Show empty state if no items left
                      const emptyEl = document.getElementById(
                        "wishlist-empty-state"
                      );
                      const paginationEl = document.getElementById(
                        "wishlist-pagination"
                      );
                      if (emptyEl) emptyEl.style.display = "";
                      if (paginationEl) paginationEl.style.display = "none";
                      observer.disconnect(); // Stop observing when empty
                    } else {
                      // Navigate to previous page or page 1 if current page is beyond available pages
                      currentPage = Math.min(currentPage, totalPages);
                      if (currentPage < 1) currentPage = 1;
                      await renderWishlistPage(currentPage);
                    }
                  } else {
                    // Just update pagination controls
                    updatePaginationControls();
                  }
                }, 300);
              }
            }
          }
        }
      });
    });

    // Observe all wishlist buttons for attribute changes
    const wishlistButtons = wishlistGrid.querySelectorAll(
      ".wishlist-toggle-btn"
    );
    wishlistButtons.forEach((button) => {
      observer.observe(button, {
        attributes: true,
        attributeFilter: ["class"],
      });

      // Also observe the SVG element for fill attribute changes
      const svg = button.querySelector("svg");
      if (svg) {
        observer.observe(svg, {
          attributes: true,
          attributeFilter: ["fill", "class"],
        });
      }
    });

    return observer;
  }

  function escapeHtml(str) {
    if (!str) return "";
    return String(str)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/\"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  // Expose functions globally for use by other scripts
  window.isUserLoggedIn = isUserLoggedIn;
  window.triggerLoginWrapper = triggerLoginWrapper;
  window.addToWishlist = addToWishlist;
  window.showToast = showToast;
  window.loadUserWishlist = loadUserWishlist;
});
